import React from 'react';
import server from '../../server';

export class LockedModal extends React.Component{
    render(){
        return(
            <div onClick={this.props.close} class={"custom-modal-overlay " + (this.props.open == true ? "show-custom-modal-overlay" : "hidden-custom-modal-overlay")}>
                <div class={"custom-modal bgc-white bd bdrs-2 " + (this.props.open == true ? "show" : "hide")}>
                    <div class="custom-modal__title">
                        <h3 class="m-0 ta-c">Horário Trancado</h3>
                    </div>
                    <div class="custom-modal__content">
                        <div class="pB-0 peers jc-c ai-c mB-10 pX-30">
                            <p>{this.props.locked ? this.props.locked.description : ""}</p>
                        </div>
                    </div>
                    <div class="custom-modal__footer peers jc-c">
                        <button onClick={this.props.close} class="btn btn-default close-modal mR-20" type="button">Voltar</button>
                        <button onClick={this.props.unlock} class="btn btn-default close-modal" type="button">Destrancar</button>
                    </div>
                </div>
            </div>
        )
    }
}

export class LockModal extends React.Component{
    state={description: "", weekly:false, weekly_period:0}

    render(){
        return(
            <div class={"custom-modal-overlay " + (this.props.open == true ? "show-custom-modal-overlay" : "hidden-custom-modal-overlay")}>
                <div class={"custom-modal bgc-white bd bdrs-2 " + (this.props.open == true ? "show" : "hide")}>
                    <div class="custom-modal__title">
                        <h3 class="m-0 ta-c">Trancar Horários</h3>
                    </div>
                    <div class="custom-modal__content">
                        <div style={{flexDirection:"column"}} class="pB-0 peers jc-c ai-c mB-10 pX-30">
                            <textarea 
                                maxLength="100" 
                                style={{resize:"none", width:200, height:200}} 
                                placeholder="Descrição"
                                value={this.state.description}
                                onChange={(e) => this.setState({description:e.target.value})}>
                                
                            </textarea>
                            <br/>
                            <div style={{alignItems:"baseline"}} class="checkbox checkbox-circle checkbox-client-default ai-c">
                                <input checked={this.state.weekly} onChange={(e) => this.setState({weekly:e.target.checked})} id="Rio" name="rio" type="checkbox"/>
                                <label class="ai-c" for="Rio">
                                    <span class="peer peer-greed">Semanal</span>
                                </label>
                            </div>

                            {this.state.weekly ?
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    <label>Por quantas semanas?</label>
                                    <input value={this.state.weekly_period} onChange={(e) => this.setState({weekly_period: e.target.value})} type="number" placeholder="Quantas semanas?"/>
                                </div>
                            :<div></div>}
                        </div>
                    </div>
                    <div class="custom-modal__footer peers jc-c">
                        <button onClick={this.props.close} class="btn btn-default close-modal mR-20" type="button">Cancelar</button>
                        <button onClick={() => this.props.lock(this.state)} class="btn btn-default close-modal" type="button">Trancar</button>
                    </div>
                </div>
            </div>
        )
    }
}

export class NotAvailableModal extends React.Component{
    render(){
        return(
            <div onClick={this.props.close} class={"custom-modal-overlay " + (this.props.open == true ? "show-custom-modal-overlay" : "hidden-custom-modal-overlay")}>
                <div class={"custom-modal bgc-white bd bdrs-2 " + (this.props.open == true ? "show" : "hide")}>
                    <div class="custom-modal__title">
                        <h3 class="m-0 ta-c">Horário não disponível</h3>
                    </div>
                    <div class="custom-modal__content">
                        <div class="pB-0 peers jc-c ai-c mB-10 pX-30">
                            <img class="w-10r bdrs-50p user-image bdc-client-default" src="https://randomuser.me/api/portraits/men/10.jpg" alt=""/>
                            <div class="mL-20">
                                <h4 class="m-0">
                                    <b>{this.props.book.name}</b>
                                </h4>
                                <p class="m-0 c-client-secondary">
                                    <i class="fa fa-envelope  c-client-default"></i>{this.props.book.email}</p>
                                <p class="m-0  c-client-secondary">
                                    <i class="fa fa-phone  c-client-default"></i>{this.props.book.telephone}</p>
                                <p class="m-0  c-client-secondary">
                                    <i class="fa fa-hourglass  c-client-default"></i>{server.fullDateString(this.props.book.start)}</p>
                            </div>
                        </div>
                    </div>
                    <div class="custom-modal__footer peers jc-c">
                        <button onClick={this.props.close} class="btn btn-default close-modal" type="button">Ok</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/schedule/Modals.js